import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Login from "./Login";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isEkipDropdownOpen, setIsEkipDropdownOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const isActive = (path: string) => {
    const currentPath = location.pathname.replace(/\/$/, "");
    const comparePath = path.replace(/\/$/, "");
    return currentPath === comparePath;
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-[9999] w-full transition-all duration-300 bg-black/95 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <div className="flex items-center flex-shrink-0">
            <Link to="/" className="flex items-center space-x-3 group">
              <div className="relative h-12 w-12 rounded-full overflow-hidden ring-2 ring-blue-500/30 group-hover:ring-blue-500/50 transition-all duration-300">
                <img
                  className="h-full w-full object-cover transform group-hover:scale-110 transition-transform duration-300"
                  src="/images/kolektif.jpeg"
                  alt="Kolektif Oluşum"
                />
              </div>
              <span className="text-xl text-white hidden sm:block font-sans font-medium group-hover:text-blue-400 transition-colors duration-300">
                Kolektif Oluşum
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden xl:flex items-center justify-center flex-1 px-16 space-x-16">
            <Link
              to="/hakkimizda"
              className={`text-gray-300 hover:text-white transition-colors font-sans relative pb-1 after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:origin-center after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300 ${
                isActive("/hakkimizda")
                  ? "text-white after:bg-blue-500 after:scale-x-100"
                  : "after:bg-white"
              }`}
            >
              Hakkımızda
            </Link>
            <div className="relative group">
              <button
                className={`text-gray-300 hover:text-white transition-colors flex items-center font-sans ${
                  isActive("/ekibimiz") ? "text-white" : ""
                }`}
              >
                Ekibimiz
                <svg
                  className="w-4 h-4 ml-1 transform group-hover:rotate-180 transition-transform duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              <div className="absolute left-0 mt-2 w-64 bg-black/95 backdrop-blur-md border border-white/10 rounded-xl shadow-xl py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform group-hover:translate-y-0 translate-y-2">
                <Link
                  to="/ekibimiz/genel-baskan"
                  className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-white/5 transition-colors font-sans"
                >
                  Genel Başkan
                </Link>
                <Link
                  to="/ekibimiz/yonetim-kurulu"
                  className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-white/5 transition-colors font-sans"
                >
                  Yönetim Kurulu
                </Link>
                {/* <Link
                  to="/ekibimiz/kolektif-liseler"
                  className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-white/5 transition-colors font-sans"
                >
                  Kolektif Liseler
                </Link> */}
                <Link
                  to="/ekibimiz/kolektif-genclik"
                  className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-white/5 transition-colors font-sans"
                >
                  Kolektif Gençlik
                </Link>
                <Link
                  to="/ekibimiz/kolektif-avrupa"
                  className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-white/5 transition-colors font-sans"
                >
                  Kolektif Avrupa
                </Link>
              </div>
            </div>
            <Link
              to="/etkinliklerimiz"
              className={`text-gray-300 hover:text-white transition-colors font-sans relative pb-1 after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:origin-center after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300 ${
                isActive("/etkinliklerimiz")
                  ? "text-white after:bg-blue-500 after:scale-x-100"
                  : "after:bg-white"
              }`}
            >
              Etkinliklerimiz
            </Link>
            <Link
              to="/indirimler"
              className={`text-gray-300 hover:text-white transition-colors font-sans relative pb-1 after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:origin-center after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300 ${
                isActive("/indirimler")
                  ? "text-white after:bg-blue-500 after:scale-x-100"
                  : "after:bg-white"
              }`}
            >
              İndirimler
            </Link>
            <Link
              to="/sss"
              className={`text-gray-300 hover:text-white transition-colors font-sans relative pb-1 after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:origin-center after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300 ${
                isActive("/sss")
                  ? "text-white after:bg-blue-500 after:scale-x-100"
                  : "after:bg-white"
              }`}
            >
              SSS
            </Link>
            <Link
              to="/iletisim"
              className={`text-gray-300 hover:text-white transition-colors font-sans relative pb-1 after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:origin-center after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300 ${
                isActive("/iletisim")
                  ? "text-white after:bg-blue-500 after:scale-x-100"
                  : "after:bg-white"
              }`}
            >
              İletişim
            </Link>
          </div>

          <div className="hidden xl:flex items-center space-x-6 flex-shrink-0">
            <Login onNavigate={() => setIsOpen(false)} />
          </div>

          {/* Mobile Menu Button */}
          <div className="xl:hidden flex items-center">
            <button
              onClick={toggleMenu}
              className="text-white hover:text-gray-200 focus:outline-none"
            >
              <span className="sr-only">Menüyü aç</span>
              {!isOpen ? (
                <svg
                  className="h-8 w-8"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              ) : (
                <svg
                  className="h-8 w-8"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`xl:hidden fixed inset-0 transition-all duration-500 ease-in-out shadow-2xl ${
          isOpen
            ? "opacity-100 translate-y-0 pointer-events-auto"
            : "opacity-0 -translate-y-full pointer-events-none"
        }`}
        style={{
          top: "96px",
        }}
      >
        <div className="px-4 pt-6 pb-4 space-y-3 h-[calc(100vh-96px)] overflow-y-auto bg-black">
          <Link
            to="/hakkimizda"
            className={`block px-5 py-4 text-lg font-sans font-medium text-white rounded-xl transition-all duration-200 ${
              isActive("/hakkimizda")
                ? "bg-white/10 shadow-lg shadow-black/30"
                : "hover:bg-white/5"
            }`}
            onClick={toggleMenu}
          >
            Hakkımızda
          </Link>
          <div className="px-4 py-3">
            <button
              onClick={() => setIsEkipDropdownOpen(!isEkipDropdownOpen)}
              className={`flex items-center justify-between w-full text-lg font-sans font-medium text-white rounded-xl px-2 py-1 ${
                isActive("/ekibimiz") ? "text-white" : ""
              }`}
            >
              Ekibimiz
              <svg
                className={`w-5 h-5 transform transition-transform duration-300 ${
                  isEkipDropdownOpen ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            <div
              className={`mt-2 space-y-1 transition-all duration-300 overflow-hidden ${
                isEkipDropdownOpen
                  ? "max-h-[500px] opacity-100"
                  : "max-h-0 opacity-0"
              }`}
            >
              <div className="py-2 space-y-2 pl-4">
                <Link
                  to="/ekibimiz/genel-baskan"
                  className="block px-5 py-3 text-white/80 hover:text-white hover:bg-white/5 rounded-lg font-sans"
                  onClick={toggleMenu}
                >
                  Genel Başkan
                </Link>
                <Link
                  to="/ekibimiz/yonetim-kurulu"
                  className="block px-5 py-3 text-white/80 hover:text-white hover:bg-white/5 rounded-lg font-sans"
                  onClick={toggleMenu}
                >
                  Yönetim Kurulu
                </Link>
                <Link
                  to="/ekibimiz/kolektif-avrupa"
                  className="block px-5 py-3 text-white/80 hover:text-white hover:bg-white/5 rounded-lg font-sans"
                  onClick={toggleMenu}
                >
                  Kolektif Avrupa
                </Link>
                {/* <Link
                  to="/ekibimiz/kolektif-liseler"
                  className="block px-5 py-3 text-white/80 hover:text-white hover:bg-white/5 rounded-lg font-sans"
                  onClick={toggleMenu}
                >
                  Kolektif Liseler
                </Link> */}
                <Link
                  to="/ekibimiz/kolektif-genclik"
                  className="block px-5 py-3 text-white/80 hover:text-white hover:bg-white/5 rounded-lg font-sans"
                  onClick={toggleMenu}
                >
                  Kolektif Gençlik
                </Link>
              </div>
            </div>
          </div>
          <Link
            to="/etkinliklerimiz"
            className={`block px-5 py-4 text-lg font-sans font-medium text-white rounded-xl transition-all duration-200 ${
              isActive("/etkinliklerimiz")
                ? "bg-white/10 shadow-lg shadow-black/30"
                : "hover:bg-white/5"
            }`}
            onClick={toggleMenu}
          >
            Etkinliklerimiz
          </Link>
          <Link
            to="/indirimler"
            className={`block px-5 py-4 text-lg font-sans font-medium text-white rounded-xl transition-all duration-200 ${
              isActive("/indirimler")
                ? "bg-white/10 shadow-lg shadow-black/30"
                : "hover:bg-white/5"
            }`}
            onClick={toggleMenu}
          >
            İndirimler
          </Link>
          <Link
            to="/sss"
            className={`block px-5 py-4 text-lg font-sans font-medium text-white rounded-xl transition-all duration-200 ${
              isActive("/sss")
                ? "bg-white/10 shadow-lg shadow-black/30"
                : "hover:bg-white/5"
            }`}
            onClick={toggleMenu}
          >
            SSS
          </Link>
          <Link
            to="/iletisim"
            className={`block px-5 py-4 text-lg font-sans font-medium text-white rounded-xl transition-all duration-200 ${
              isActive("/iletisim")
                ? "bg-white/10 shadow-lg shadow-black/30"
                : "hover:bg-white/5"
            }`}
            onClick={toggleMenu}
          >
            İletişim
          </Link>
          <div className="px-4 py-6 mt-4">
            <div className="xl:hidden">
              <Login onNavigate={() => setIsOpen(false)} />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
